<template>
  <iframe
    v-iframe-resize="{ heightCalculationMethod: 'lowestElement' }"
    v-bind="$attrs"
    class="dotcom-iframe"
  ></iframe>
</template>

<script>
import IframeResize from '../../directives/iframe-resize'

export default {
  name: 'DotcomIframe',
  directives: {
    IframeResize,
  },
}
</script>

<style lang="postcss" scoped>
.dotcom-iframe {
  width: 1px;
  min-width: 100%;
}
</style>
